import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'

const AdvisoryApp = lazy(() => import('./advisory/AdvisoryApp'))

const path = window.location.pathname.replace(/\/+$/, '') || '/'
const publicCpq = path === '/advisory/cpq'
if (!publicCpq && (path === '/' || ((path.startsWith('/advisory/kiosk') || path.startsWith('/advisory/review')) && !path.startsWith('/advisory/continue')))) {
  history.replaceState(null, '', '/advisory' + window.location.search)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="min-h-screen bg-slate-950 text-slate-100">Loading aviOS Advisor…</div>}>
      <AdvisoryApp />
    </Suspense>
  </StrictMode>,
)
